import { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import { FullScreenLoading } from '../Components/Common/loader/FullScreenLoading'
import { InvalidTokenMessage } from './components/InvalidTokenMessage'
import { COMPONENT_STATUS } from '../infra/constants/ComponentStatus'
import { validateTemporaryToken } from '../infra/utils/validateToken'
import { ERROR_TYPES } from '../infra/constants/ErrorTypes'


const SmartProtectedRoute = ({ children }) => {
    const [searchParams] = useSearchParams()
    const urlToken = searchParams.get('token')

    const [status, setStatus] = useState(COMPONENT_STATUS.IDLE) // 'idle' | 'checking' | 'valid' | 'invalid'
    const [errorType, setErrorType] = useState(null)

    useEffect(() => {
        let mounted = true
        const controller = new AbortController()

        const run = async () => {
            setStatus(COMPONENT_STATUS.CHECKING)

            // Try localStorage token first
            const sessionToken = localStorage.getItem('authToken')
            if (sessionToken) {
                const okStored = await validateTemporaryToken(sessionToken, controller.signal)
                if (!mounted) return
                if (okStored) {
                    setStatus(COMPONENT_STATUS.VALID)
                    setErrorType(null)
                    return
                }
            }

            setStatus(COMPONENT_STATUS.INVALID)
            setErrorType(ERROR_TYPES.INVALID)

            // If not logged in, or localStorage token is invalid, validate URL token
            if (urlToken) {
                const okUrl = await validateTemporaryToken(urlToken, controller.signal)
                if (!mounted) return
                if (okUrl) {
                    localStorage.setItem('authToken', urlToken)
                    setStatus(COMPONENT_STATUS.VALID)
                    setErrorType(null)
                    return
                } else {
                    setStatus(COMPONENT_STATUS.INVALID)
                    setErrorType(ERROR_TYPES.INVALID)
                    return
                }
            }
        }

        run()

        return () => {
            mounted = false
            controller.abort()
        }
    }, [urlToken])

    useEffect(() => {
        if (!urlToken || status !== COMPONENT_STATUS.VALID) return
        const id = setInterval(async () => {
            const stillValid = await validateTemporaryToken(urlToken)
            if (!stillValid) setStatus(COMPONENT_STATUS.INVALID)
        }, 5 * 60 * 1000)
        return () => clearInterval(id)
    }, [urlToken, status])

    if (status === COMPONENT_STATUS.CHECKING) return <FullScreenLoading />
    if (status === COMPONENT_STATUS.VALID) return <>{children}</>
    return <InvalidTokenMessage type={errorType} />
}

export default SmartProtectedRoute